module.exports = __webpack_public_path__ + "img/ss.7822c950.jpg";